exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "modal-request .responsiveMobile .modal-dialog{max-height:none;max-width:none}modal-request .modal-dialog{max-height:410px;max-width:520px}modal-request .modal{transition:.3s;opacity:0;top:-50px}modal-request .modal.in{opacity:1;top:0;transition:.3s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/modals/modalRequest/modalRequest.scss
// module id = 1372
// module chunks = 0